import React from 'react'
import {MainMenu} from './MainMenu'

interface ITaskHeaderProps {
  isNewYear: boolean
}

const TaskHeader: React.FC<ITaskHeaderProps> = ({isNewYear}) => {
  return (
    <div className={'main-header-fullwidth-container'}>
      <div className={'main-header task-header task-container main-menu-container-mobile'}>
        <div className={'main-header-logo-wrapper'}>
          <a href={'/'}>
            <img
              src={isNewYear ? '/img/new-year-logo.svg' : '/img/logo-white.svg'}
              width={124}
              height={15}
              alt={'Логотип'}
              className={'task-header-logo'}
            />
            <img
              src={'/img/logo-small-white.svg'}
              width={46}
              height={24}
              alt={'Логотип'}
              className={'task-header-logo-min'}
            />
          </a>
        </div>
        <div className={'main-menu-container-pc-task'}>
          <MainMenu isTaskHeader={true} />
        </div>
      </div>
    </div>
  )
}

export {TaskHeader}
